
import { defineComponent, ref } from 'vue'
import { useStore } from 'vuex'
import { useI18n } from 'vue-i18n'

export default defineComponent({
    props: {
        zoomRatio: {
            type: Number,
            required: true,
            default: 1
        },
        baseRatio: {
            type: Number,
            required: true,
            default: 1
        }
    },
    setup(props) {
        const { t } = useI18n()
        const store = useStore()
        const systemsInfo = ref([
            {
                imagestyle: 'bx',
                systemTitle: '八仙 XBOAT',
                systemFirstcontent: t('message.baxianSystemFirstcontent'),
                systemSecondcontent: t('message.baxianSystemSecondcontent')
            },
            {
                imagestyle: 'ml',
                systemTitle: '马良 XCUBE',
                systemFirstcontent: t('message.maliangSystemFirstcontent'),
                systemSecondcontent: t('message.maliangSystemSecondcontent')
            },
            {
                imagestyle: 'dy',
                systemTitle: '大禹 XAQUE',
                systemFirstcontent: t('message.dayuSystemFirstcontent'),
                systemSecondcontent: t('message.dayuSystemSecondcontent')
            },
            {
                imagestyle: 'jz',
                systemTitle: '玖洲 XLAND',
                systemFirstcontent: t('message.jiuzhouSystemFirstcontent'),
                systemSecondcontent: t('message.jiuzhouSystemSecondcontent')
            },
        ])
        const beforeChange = (from: any, to: any) => {
            // console.log('from: ' + from, 'to: ' + to, store.state.count)
            store.commit('dotsChange', to)
        }
        return {
            systemsInfo,
            beforeChange
        }
    }
})
